export default __webpack_public_path__ + "static/media/rmvBtn.928e7c9b.svg";